import React from "react";

const ContactTableLoader = props => {
  const { count = 10 } = props;
  return (
    <>
      {Array.from({ length: count }, (value, index) => (
        <div className="contact contactTableLoader" key={`contact ${index}`}>
          <div className="stickyLeftCol" role="presentation">
            <div className="ctSelectAll dataContainer">
              <span className="linear-background"></span>
            </div>
            <div className="nameCont dataContainer" title="Contact">
              <span
                className="linear-background darkText"
                style={{ width: "50%" }}
              ></span>
              <span
                className="linear-background darkText"
                style={{ width: "70%" }}
              ></span>
            </div>
          </div>
          <div className="titleCont dataContainer" title="Title">
            <span
              className="linear-background darkText"
              style={{ width: "50%" }}
            ></span>
            <span
              className="linear-background darkText"
              style={{ width: "70%" }}
            ></span>
          </div>
          <div className="companyCont dataContainer" title="Company">
            <span
              className="linear-background darkText"
              style={{ width: "50%" }}
            ></span>
            <span
              className="linear-background darkText"
              style={{ width: "70%" }}
            ></span>
          </div>
          <div className="socialLinksCont dataContainer" title="Social Links">
            <span className="linear-background darkText" style={{ width: "60%" }}></span>
          </div>
          <div className="sizeCont dataContainer" title="Company Size">
            <span className="linear-background darkText" style={{ width: "40%" }}></span>
          </div>
          <div className="revenueCont dataContainer" title="Annual Revenue">
            <span className="linear-background darkText" style={{ width: "50%" }}></span>
          </div>
          <div className="locationCont dataContainer" title="Company Location">
            <span className="linear-background darkText" style={{ width: "55%" }}></span>
          </div>
          <div className="industryCont dataContainer" title="Industry">
            <span className="linear-background darkText" style={{ width: "45%" }}></span>
          </div>
          <div className="emailCont dataContainer" title="Email">
            <span className="linear-background darkText" style={{ width: "70px" }}></span>
          </div>
          <div className="mobileCont dataContainer" title="Mobile">
            <span className="linear-background darkText" style={{ width: "70px" }}></span>
          </div>
        </div>
      ))}
    </>
  );
};

export default ContactTableLoader;
export { ContactTableLoader };
